<template>
  <v-container fluid>
    <div class="dashboard-home-title">
      <!-- <h1>Home</h1> -->
      <v-tabs v-model="maintabs" background-color="white" grow>
        <v-tab
          v-for="(tab, i) in mainTabHeadings"
          :key="i"
          :class="'text-capitalize'"
        >
          {{ tab }}
        </v-tab>
      </v-tabs>
      <div class="view-as-block">
        <span>Viewing As</span>
        <base-role-switcher :chosenUser.sync="tempMe" :initial="me" />
      </div>
    </div>
    <v-tabs-items v-model="maintabs">
      <v-tab-item>
        <v-card flat>
          <under-construction />
        </v-card>
      </v-tab-item>
      <v-tab-item>
        <div class="dashboard-tab-item">
          <v-tabs fixed-tabs v-model="nexReminder">
            <v-tabs-slider color="#069697 "></v-tabs-slider>
            <v-tab
              class="hq-tabs"
              v-for="(tab, i) in nexReminderTabs"
              :key="i"
              :class="'top-table-nav tab-' + i"
            >
              {{ tab.name }}
            </v-tab>
          </v-tabs>
          <v-tabs-items v-model="nexReminder">
            <v-tab-item v-for="(tab, i) in nexReminderTabs" :key="i">
              <next-step-section
                :tableName="tab.name"
                :queryLimit="tab.value"
                :dataChangedForAll="dataChanged"
                :refreshAll.sync="dataChanged"
              /> </v-tab-item
          ></v-tabs-items>
        </div>
      </v-tab-item>
      <v-tab-item>
        <div class="dashboard-tab-item">
          <v-tabs fixed-tabs v-model="leadDeals">
            <v-tabs-slider color="#069697 "></v-tabs-slider>
            <v-tab
              class="hq-tabs"
              v-for="(tab, i) in leadDealsTab"
              :key="i"
              :class="'top-table-nav tab-' + i"
            >
              {{ tab }}
            </v-tab>
          </v-tabs>

          <v-tabs-items v-model="leadDeals">
            <v-tab-item>
              <!-- <v-expansion-panels class="expand-filter-block">
                <v-expansion-panel :active-class="'now-on'">
                  <v-expansion-panel-header>
                    <h4>
                      <span class="on">Show</span>
                      <span class="off">Hide</span> Filters
                    </h4>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <enquiry-filter
                      :enquiryFilters.sync="enquiryOptions"
                      :showBroker="false"
                    />
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels> -->

              <enquiry-section
                :filterToUser="true"
                :changeMe="me"
                :enquiryOptions="enquiryOptions"
                :preSelect="preSelect"
              />
            </v-tab-item>
            <v-tab-item>
              <!-- <v-expansion-panels class="expand-filter-block">
                <v-expansion-panel :active-class="'now-on'">
                  <v-expansion-panel-header>
                    <h4>
                      <span class="on">Show</span>
                      <span class="off">Hide</span> Filters
                    </h4>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <lead-filter
                      :leadFilters.sync="leadOptions"
                      :showBroker="false"
                    />
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels> -->

              <lead-section
                :filterToUser="true"
                :changeMe="me"
                :leadOptions="leadOptions"
              />
            </v-tab-item>

            <v-tab-item>
              <!-- <v-expansion-panels class="expand-filter-block">
                <v-expansion-panel :active-class="'now-on'">
                  <v-expansion-panel-header>
                    <h4>
                      <span class="on">Show</span>
                      <span class="off">Hide</span> Filters
                    </h4>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <lead-filter
                      :leadFilters.sync="investorOptions"
                      :showBroker="false"
                      :onlyInvestor="true"
                    />
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels> -->
              <lead-section
                :filterToUser="true"
                :changeMe="me"
                :leadOptions="investorOptions"
                :onlyInvestor="true"
              />
            </v-tab-item>

            <v-tab-item>
              <!-- <v-expansion-panels class="expand-filter-block">
                <v-expansion-panel :active-class="'now-on'">
                  <v-expansion-panel-header>
                    <h4>
                      <span class="on">Show</span>
                      <span class="off">Hide</span> Filters
                    </h4>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <deal-filter
                      :dealFilters.sync="dealOptions"
                      :showBroker="false"
                    />
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels> -->

              <deal-section
                :filterToUser="true"
                :changeMe="me"
                :dealOptions="dealOptions"
              />
            </v-tab-item>
          </v-tabs-items>
        </div>
      </v-tab-item>
      <v-tab-item>
        <div class="dashboard-tab-item">
          <!-- <div class="for-props leadSwitch longer mb-3 pt-0">
            <span>{{ `Show ${showNewListings ? "Old" : "New"} Listing` }}</span>
            <v-switch
              v-model="showNewListings"
              hide-details
              color="primary"
              inset
            />
          </div> -->

          <div v-if="showNewListings">
            <div class="expand-filter-block">
              <listing-filter
                :listingFilters.sync="listingOptions"
                :showBroker="false"
              />
            </div>

            <listing-section
              :filterToUser="true"
              :changeMe="me"
              :listingOptions="listingOptions"
              :passedPageLimit="50"
            />
          </div>
          <div v-else>
            <v-tabs fixed-tabs v-model="listings">
              <v-tabs-slider color="#069697 "></v-tabs-slider>
              <v-tab
                class="hq-tabs"
                v-for="(tab, i) in listingsTab"
                :key="i"
                :class="'top-table-nav tab-' + i"
              >
                {{ tab }}
              </v-tab>
            </v-tabs>

            <v-tabs-items v-model="listings">
              <v-tab-item>
                <!-- <deal-option-listing-section
                :queryLimit="{ buildingData: { $ne: null } }"
                :tableName="'For Sale'"
              /> -->

                <buildings-for-sale
                  :queryLimit="{
                    forSale: true,
                    $or: [
                      { listingBroker: { id: me?.id } },
                      { activeBroker: { id: me?.id } },
                      { auctionBroker: { id: me?.id } },
                    ],
                  }"
                  :tableName="`Buildings for Sale (Only Broker's)`"
                />
              </v-tab-item>

              <v-tab-item>
                <!-- <deal-option-listing-section
                :queryLimit="{ unitData: { $ne: null } }"
                :tableName="'To Let'"
              /> -->
                <unit-for-lease :changeMe="me" />
              </v-tab-item>

              <v-tab-item>
                <portal-table-section
                  :tableName="`Property24 Listings (Only Broker's)`"
                  :queryLimit="{ website: { $ne: true, p24Agent: me?.id } }"
                />
              </v-tab-item>
              <v-tab-item>
                <portal-table-section
                  :tableName="`Website Listings (Only Broker's)`"
                  :queryLimit="{ website: true, p24Agent: me?.id }"
                />
              </v-tab-item>
            </v-tabs-items>
          </div>
        </div>
      </v-tab-item>
      <v-tab-item>
        <v-card flat> </v-card>
        <div class="dashboard-tab-item">
          <v-tabs fixed-tabs v-model="addedRemoved">
            <v-tabs-slider color="#069697 "></v-tabs-slider>
            <v-tab
              class="hq-tabs"
              v-for="(tab, i) in addedRemovedTab"
              :key="i"
              :class="'top-table-nav tab-' + i"
            >
              {{ tab }}
            </v-tab>
            <v-tabs-items v-model="addedRemoved">
              <v-tab-item> <under-construction /> </v-tab-item>
              <v-tab-item><under-construction /></v-tab-item>
            </v-tabs-items>
          </v-tabs>
        </div>
      </v-tab-item>
    </v-tabs-items>
  </v-container>
</template>

<script>
import NextStepSection from "@/components/Base/Dashboards/NextStepSection.vue";
import dealOptionListingSection from "@/components/Base/Dashboards/dealOptionListingSection.vue";
import buildingsForSale from "@/components/Base/Dashboards/buildingsForSale.vue";
import unitForLease from "@/components/Base/Dashboards/unitForLease.vue";
import EnquiryFilter from "@/components/Base/LeadsDeals/EnquiryFilter";
import LeadFilter from "@/components/Base/LeadsDeals/LeadFilter";
import DealFilter from "@/components/Base/LeadsDeals/DealFilter";
import EnquirySection from "@/components/Base/LeadsDeals/EnquirySection.vue";
import LeadSection from "@/components/Base/LeadsDeals/LeadSection.vue";
import DealSection from "@/components/Base/LeadsDeals/DealSection.vue";
import PortalTableSection from "@/components/Base/Property/PropertyBlocks/BuildingBlocks/PortalTableSection";
import UnderConstruction from "@/components/Base/Global/UnderConstruction.vue";
import ListingSection from "@/components/Base/Listings/ListingSection";
import ListingFilter from "@/components/Base/Listings/ListingFilter";
import { gql } from "apollo-boost";
import { GET_ENQUIRIES_COUNT } from "@/queries/enquiry";
export default {
  components: {
    NextStepSection,
    dealOptionListingSection,
    buildingsForSale,
    unitForLease,
    EnquiryFilter,
    LeadFilter,
    DealFilter,
    EnquirySection,
    LeadSection,
    DealSection,
    PortalTableSection,
    UnderConstruction,
    ListingFilter,
    ListingSection,
  },
  name: "Dashboard",
  data() {
    return {
      maintabs: 2,
      mainTabHeadings: [
        "Rebase Overview",
        "Next Steps",
        "Leads & Deals",
        "Listings",
        "Added & removed",
      ],
      nexReminder: 0,
      leadDeals: 0,
      leadDealsTab: [
        "Uncontacted Leads",
        "Active Leads",
        "Investors",
        "Deals in Progess",
      ],
      enquiryOptions: {},
      leadOptions: {},
      investorOptions: {},
      dealOptions: {},
      listingOptions: {},
      showNewListings: true,
      listingsTab: ["For Sale", "To Let", "Website", "Property24"],
      listings: 0,
      addedRemovedTab: ["Added", "Removed"],
      addedRemoved: 0,
      dataChanged: null,
      originalMe: null,
      tempMe: null,
      me: null,
      preSelect: null,
    };
  },
  apollo: {
    me: {
      query: gql`
        query {
          me {
            id
            firstName
            lastName
            division
            email
            role
            profilePicture
          }
        }
      `,
      result({ data }, key) {
        this.originalMe = data?.me;
        this.me = data?.me;
        // this.getUncontacted();
      },
    },
  },
  computed: {
    nexReminderTabs() {
      const today = new Date();
      const startOfDay = new Date(today.setHours(0, 0, 0, 0)).getTime();
      const endOfDay = new Date(today.setHours(23, 59, 59, 999)).getTime();

      var a = [
        {
          name: "Due Today",
          value: {
            date: { $gte: startOfDay, $lte: endOfDay },
            isDone: { $ne: true },
            brokerId: this.me?.id, //  $or: [{ brokerId: this.me.id }, { createdBy: this.me.id }],
          },
        },
        {
          name: "Overdue",
          value: {
            date: { $lt: startOfDay },
            isDone: { $ne: true },
            brokerId: this.me?.id, //   $or: [{ brokerId: this.me.id }, { createdBy: this.me.id }], // brokerId: this.me.id,
          },
        },
        {
          name: "Upcoming",
          value: {
            date: { $gt: endOfDay },
            isDone: { $ne: true },
            brokerId: this.me?.id, //$or: [{ brokerId: this.me.id }, { createdBy: this.me.id }], // brokerId: this.me.id,
          },
        },

        // { name: "Overdue", value: { date: { $gt: endOfDay } } },
        // { name: "Upcoming", value: { date: { $lt: startOfDay } } },
      ];

      return a;
    },
  },
  watch: {
    tempMe: {
      handler(newVal, oldVal) {
        this.me = newVal?.id ? newVal : this.originalMe;
      },
      deep: true,
    },
  },
  methods: {
    async getUncontacted() {
      var query = {
        broker: this.me.id,
        // countOnly: true,
        "contacted.0": { $exists: false }, //lastContacted
        isArchived: { $ne: true },
        isReady: { $ne: true },
        alerted: { $ne: true },
      };

      const response = await this.$apollo.query({
        query: GET_ENQUIRIES_COUNT,
        errorPolicy: "all",
        fetchPolicy: "network-only",
        variables: {
          limit: 0,
          skip: 0,
          query: query,
        },
      });

      if (!response.data.enquiries.count || response.data.enquiries.count == 0)
        return;

      const result = await this.$swal({
        title: "Alert",
        text: `You have ${response.data.enquiries.count} New Uncontacted Lead${
          response.data.enquiries.count == 1 ? "" : "s"
        }`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Show Leads",
      });
      if (result.value) {
        this.isLoading = true;
        this.preSelect = response.data.enquiries.records.map((e) => e.id);
        for (const id of response.data.enquiries.records) {
          await this.$apollo.mutate({
            mutation: gql`
              mutation update($enquiry: EnquiryUpdateInput!) {
                updateEnquiry(enquiry: $enquiry) {
                  id
                }
              }
            `,
            variables: {
              id: id,
              alerted: true,
              updatedBy: this.me.id,
            },
          });
        }
      }
    },
  },
};
</script>

<style lang="scss">
.v-tab--active {
  border-bottom: 2px solid var(--v-primary-base) !important;
  font-weight: bold;
  color: var(--v-primary-base) !important;
}

.text-capitalize {
  text-transform: none;
}

.dashboard-home-title {
  display: flex;
  background-color: #fff;
  padding: 1px 10px;
  margin-bottom: 5px;
}

.dashboard-home-title h1 {
  padding-bottom: 10px;
  margin-left: 0px;
  color: #100a55 !important;
}

.dashboard-home-title .v-tab {
  font-size: 16px !important;
  font-weight: 600;
  color: rgba(0, 0, 0, 0.4) !important;
}
.dashboard-home-title .v-tab.v-tab--active {
  color: #555 !important;
  font-weight: 600;
}
/*tabs*/

.dashboard-tab-item .theme--light.v-tabs > .v-tabs-bar {
  background-color: transparent !important;
}

.dashboard-tab-item .hq-tabs.v-tab {
  text-transform: none;
  font-size: 14px;
  height: 37px;
  width: auto !important;
  color: #5e5873 !important;
  font-weight: 600;
}

.dashboard-tab-item .hq-tabs.v-tab.v-tab--active {
  background-color: #8fc7c0;
  border-radius: 6px;
  color: #022e41 !important;
  border: solid 1px #8fc7c0;
}
.dashboard-tab-item .v-tabs-slider-wrapper {
  display: none !important;
}

.view-as-block {
  color: #555 !important;
  font-weight: 600;
  display: flex;
}

.view-as-block > span {
  min-width: 100px;
  height: 100%;
  padding-top: 20px;
}

.view-as-block .v-text-field.v-autocomplete:not(.v-text-field--enclosed) {
  height: 50px;
  margin-top: 1px;
}

.expand-filter-block.v-expansion-panels {
  box-shadow: none;
  border-radius: 8px;
  padding: 10px;
  background-color: #fff;
  border: 1px solid #e0def7;
  margin-bottom: 20px;
}
.expand-filter-block .v-expansion-panel .v-expansion-panel-header {
  padding: 0px 10px 5px 0;
}

.expand-filter-block .v-expansion-panel-header,
.expand-filter-block .v-expansion-panel--active > .v-expansion-panel-header {
  min-height: unset;
}

.expand-filter-block .v-expansion-panel-content {
  margin-bottom: 0px;
}

.expand-filter-block h4 {
  color: #3c4858;
  font-size: 18px;
  padding-top: 7px;
  padding-bottom: 2px;
  font-weight: 500;
}

.expand-filter-block .off,
.expand-filter-block .now-on .on {
  display: none;
}

.expand-filter-block .now-on .off {
  display: inline;
}
</style>
